import React from 'react'
import { toast } from 'react-toastify'

const errorSigninToast = errorMsg => {
  toast.error(
    <div>
      Passcode หรือ Portal URL ของคุณ<br />
      ไม่ถูกต้อง, โปรดลองใหม่อีกครั้ง<br />
      <small className="is-small has-text-white">{errorMsg}</small>
    </div>,
    {
      position: toast.POSITION.TOP_CENTER,
    },
  )
}

export default errorSigninToast



// WEBPACK FOOTER //
// ./src/components/templates/toast/errorSigninToast.js